// Specialist display names for profession dropdown in onboarding
export const aiServicesMessages = {
    en: {
        aiServices: {
            nail_master: { specialist: 'Nail Master' },
            hairdresser: { specialist: 'Hairdresser' },
            barber: { specialist: 'Barber' },
            makeup_artist: { specialist: 'Makeup Artist' },
            brow_lash: { specialist: 'Brow / Lash Stylist' },
            cosmetologist: { specialist: 'Cosmetologist' },
            massage_therapist: { specialist: 'Massage Therapist' },
            permanent_makeup: { specialist: 'Permanent Makeup Artist' },
            hair_extensions: { specialist: 'Hair Extensions Specialist' },
            laser_hair_removal: { specialist: 'Laser Hair Removal Specialist' },
            personal_trainer: { specialist: 'Personal Trainer' },
            online_fitness: { specialist: 'Online Fitness Coach' },
            yoga_instructor: { specialist: 'Yoga Instructor' },
            pilates_instructor: { specialist: 'Pilates Instructor' },
            psychologist: { specialist: 'Psychologist' },
            psychotherapist: { specialist: 'Psychotherapist' },
            speech_therapist: { specialist: 'Speech Therapist' },
            rehabilitation: { specialist: 'Rehabilitation Specialist' },
            osteopath: { specialist: 'Osteopath' },
            physiotherapist: { specialist: 'Physiotherapist' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Nutritionist' },
            private_lawyer: { specialist: 'Private Lawyer' },
            attorney: { specialist: 'Attorney' },
            tax_consultant: { specialist: 'Tax Consultant' },
            accountant: { specialist: 'Accountant' },
            financial_advisor: { specialist: 'Financial Advisor' },
            mortgage_advisor: { specialist: 'Mortgage Advisor' },
            photographer: { specialist: 'Photographer' },
            videographer: { specialist: 'Videographer' },
            event_host: { specialist: 'Event Host' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Tutor' },
            language_teacher: { specialist: 'Language Teacher' },
            music_teacher: { specialist: 'Music Teacher' },
            child_psychologist: { specialist: 'Child Psychologist' },
            school_prep: { specialist: 'School Prep Tutor' },
            groomer: { specialist: 'Pet Groomer' },
            dogsitter: { specialist: 'Dog Sitter' },
            dog_walker: { specialist: 'Dog Walker' },
            dog_trainer: { specialist: 'Dog Trainer' },
        },
    },
    de: {
        aiServices: {
            nail_master: { specialist: 'Nageldesigner/in' },
            hairdresser: { specialist: 'Friseur/in' },
            barber: { specialist: 'Barber' },
            makeup_artist: { specialist: 'Visagist/in' },
            brow_lash: { specialist: 'Brow-/Lash-Stylist/in' },
            cosmetologist: { specialist: 'Kosmetiker/in' },
            massage_therapist: { specialist: 'Masseur/in' },
            permanent_makeup: { specialist: 'Permanent-Make-up-Artist' },
            hair_extensions: { specialist: 'Haarverlängerungsspezialist/in' },
            laser_hair_removal: { specialist: 'Laser-Haarentfernungsspezialist/in' },
            personal_trainer: { specialist: 'Personal Trainer/in' },
            online_fitness: { specialist: 'Online-Fitness-Coach' },
            yoga_instructor: { specialist: 'Yogalehrer/in' },
            pilates_instructor: { specialist: 'Pilates-Lehrer/in' },
            psychologist: { specialist: 'Psychologe/in' },
            psychotherapist: { specialist: 'Psychotherapeut/in' },
            speech_therapist: { specialist: 'Logopäde/in' },
            rehabilitation: { specialist: 'Rehabilitationsspezialist/in' },
            osteopath: { specialist: 'Osteopath/in' },
            physiotherapist: { specialist: 'Physiotherapeut/in' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Ernährungsberater/in' },
            private_lawyer: { specialist: 'Rechtsanwalt/Rechtsanwältin' },
            attorney: { specialist: 'Anwalt/Anwältin' },
            tax_consultant: { specialist: 'Steuerberater/in' },
            accountant: { specialist: 'Buchhalter/in' },
            financial_advisor: { specialist: 'Finanzberater/in' },
            mortgage_advisor: { specialist: 'Hypothekenberater/in' },
            photographer: { specialist: 'Fotograf/in' },
            videographer: { specialist: 'Videograf/in' },
            event_host: { specialist: 'Eventmoderator/in' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Nachhilfelehrer/in' },
            language_teacher: { specialist: 'Sprachlehrer/in' },
            music_teacher: { specialist: 'Musiklehrer/in' },
            child_psychologist: { specialist: 'Kinderpsychologe/in' },
            school_prep: { specialist: 'Schulvorbereitung' },
            groomer: { specialist: 'Tierpfleger/in' },
            dogsitter: { specialist: 'Hundesitter/in' },
            dog_walker: { specialist: 'Hundeausführer/in' },
            dog_trainer: { specialist: 'Hundetrainer/in' },
        },
    },
    ru: {
        aiServices: {
            nail_master: { specialist: 'Мастер маникюра / педикюра' },
            hairdresser: { specialist: 'Парикмахер' },
            barber: { specialist: 'Барбер' },
            makeup_artist: { specialist: 'Визажист' },
            brow_lash: { specialist: 'Бровист / лэшмейкер' },
            cosmetologist: { specialist: 'Косметолог' },
            massage_therapist: { specialist: 'Массажист' },
            permanent_makeup: { specialist: 'Мастер перманентного макияжа' },
            hair_extensions: { specialist: 'Мастер по наращиванию волос' },
            laser_hair_removal: { specialist: 'Специалист по лазерной эпиляции' },
            personal_trainer: { specialist: 'Персональный тренер' },
            online_fitness: { specialist: 'Фитнес-тренер онлайн' },
            yoga_instructor: { specialist: 'Йога-инструктор' },
            pilates_instructor: { specialist: 'Пилатес-инструктор' },
            psychologist: { specialist: 'Психолог' },
            psychotherapist: { specialist: 'Психотерапевт' },
            speech_therapist: { specialist: 'Логопед' },
            rehabilitation: { specialist: 'Реабилитолог' },
            osteopath: { specialist: 'Остеопат' },
            physiotherapist: { specialist: 'Физиотерапевт' },
            coach: { specialist: 'Коуч' },
            nutritionist: { specialist: 'Нутрициолог' },
            private_lawyer: { specialist: 'Частный юрист' },
            attorney: { specialist: 'Адвокат' },
            tax_consultant: { specialist: 'Налоговый консультант' },
            accountant: { specialist: 'Бухгалтер' },
            financial_advisor: { specialist: 'Финансовый консультант' },
            mortgage_advisor: { specialist: 'Ипотечный консультант' },
            photographer: { specialist: 'Фотограф' },
            videographer: { specialist: 'Видеограф' },
            event_host: { specialist: 'Ведущий мероприятий' },
            dj: { specialist: 'Диджей' },
            tutor: { specialist: 'Репетитор' },
            language_teacher: { specialist: 'Преподаватель иностранных языков' },
            music_teacher: { specialist: 'Музыкальный преподаватель' },
            child_psychologist: { specialist: 'Детский психолог' },
            school_prep: { specialist: 'Подготовка к школе' },
            groomer: { specialist: 'Грумер' },
            dogsitter: { specialist: 'Догситтер' },
            dog_walker: { specialist: 'Выгульщик собак' },
            dog_trainer: { specialist: 'Дрессировщик' },
        },
    },
    es: {
        aiServices: {
            nail_master: { specialist: 'Manicurista' },
            hairdresser: { specialist: 'Peluquero/a' },
            barber: { specialist: 'Barbero' },
            makeup_artist: { specialist: 'Maquillador/a' },
            brow_lash: { specialist: 'Estilista de cejas y pestañas' },
            cosmetologist: { specialist: 'Cosmetólogo/a' },
            massage_therapist: { specialist: 'Masajista' },
            permanent_makeup: { specialist: 'Maquillaje permanente' },
            hair_extensions: { specialist: 'Extensiones de cabello' },
            laser_hair_removal: { specialist: 'Depilación láser' },
            personal_trainer: { specialist: 'Entrenador personal' },
            online_fitness: { specialist: 'Entrenador fitness online' },
            yoga_instructor: { specialist: 'Instructor de yoga' },
            pilates_instructor: { specialist: 'Instructor de pilates' },
            psychologist: { specialist: 'Psicólogo/a' },
            psychotherapist: { specialist: 'Psicoterapeuta' },
            speech_therapist: { specialist: 'Logopeda' },
            rehabilitation: { specialist: 'Rehabilitador/a' },
            osteopath: { specialist: 'Osteópata' },
            physiotherapist: { specialist: 'Fisioterapeuta' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Nutricionista' },
            private_lawyer: { specialist: 'Abogado privado' },
            attorney: { specialist: 'Abogado/a' },
            tax_consultant: { specialist: 'Asesor fiscal' },
            accountant: { specialist: 'Contador/a' },
            financial_advisor: { specialist: 'Asesor financiero' },
            mortgage_advisor: { specialist: 'Asesor hipotecario' },
            photographer: { specialist: 'Fotógrafo/a' },
            videographer: { specialist: 'Videógrafo/a' },
            event_host: { specialist: 'Animador de eventos' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Tutor/a' },
            language_teacher: { specialist: 'Profesor de idiomas' },
            music_teacher: { specialist: 'Profesor de música' },
            child_psychologist: { specialist: 'Psicólogo infantil' },
            school_prep: { specialist: 'Preparación escolar' },
            groomer: { specialist: 'Peluquero de mascotas' },
            dogsitter: { specialist: 'Cuidador de perros' },
            dog_walker: { specialist: 'Paseador de perros' },
            dog_trainer: { specialist: 'Adiestrador de perros' },
        },
    },
    fr: {
        aiServices: {
            nail_master: { specialist: 'Prothésiste ongulaire' },
            hairdresser: { specialist: 'Coiffeur/se' },
            barber: { specialist: 'Barbier' },
            makeup_artist: { specialist: 'Maquilleur/se' },
            brow_lash: { specialist: 'Styliste sourcils/cils' },
            cosmetologist: { specialist: 'Esthéticien/ne' },
            massage_therapist: { specialist: 'Masseur/se' },
            permanent_makeup: { specialist: 'Maquillage permanent' },
            hair_extensions: { specialist: 'Extensions de cheveux' },
            laser_hair_removal: { specialist: 'Épilation laser' },
            personal_trainer: { specialist: 'Coach sportif' },
            online_fitness: { specialist: 'Coach fitness en ligne' },
            yoga_instructor: { specialist: 'Professeur de yoga' },
            pilates_instructor: { specialist: 'Professeur de pilates' },
            psychologist: { specialist: 'Psychologue' },
            psychotherapist: { specialist: 'Psychothérapeute' },
            speech_therapist: { specialist: 'Orthophoniste' },
            rehabilitation: { specialist: 'Spécialiste en rééducation' },
            osteopath: { specialist: 'Ostéopathe' },
            physiotherapist: { specialist: 'Kinésithérapeute' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Nutritionniste' },
            private_lawyer: { specialist: 'Avocat privé' },
            attorney: { specialist: 'Avocat/e' },
            tax_consultant: { specialist: 'Conseiller fiscal' },
            accountant: { specialist: 'Comptable' },
            financial_advisor: { specialist: 'Conseiller financier' },
            mortgage_advisor: { specialist: 'Conseiller en prêts immobiliers' },
            photographer: { specialist: 'Photographe' },
            videographer: { specialist: 'Vidéaste' },
            event_host: { specialist: 'Animateur/rice' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Tuteur/rice' },
            language_teacher: { specialist: 'Professeur de langues' },
            music_teacher: { specialist: 'Professeur de musique' },
            child_psychologist: { specialist: 'Psychologue pour enfants' },
            school_prep: { specialist: 'Préparation scolaire' },
            groomer: { specialist: 'Toiletteur/se' },
            dogsitter: { specialist: 'Dog-sitter' },
            dog_walker: { specialist: 'Promeneur de chiens' },
            dog_trainer: { specialist: 'Éducateur canin' },
        },
    },
    it: {
        aiServices: {
            nail_master: { specialist: 'Onicotecnica' },
            hairdresser: { specialist: 'Parrucchiere/a' },
            barber: { specialist: 'Barbiere' },
            makeup_artist: { specialist: 'Truccatore/rice' },
            brow_lash: { specialist: 'Brow/Lash Stylist' },
            cosmetologist: { specialist: 'Estetista' },
            massage_therapist: { specialist: 'Massaggiatore/rice' },
            permanent_makeup: { specialist: 'Trucco permanente' },
            hair_extensions: { specialist: 'Extension capelli' },
            laser_hair_removal: { specialist: 'Epilazione laser' },
            personal_trainer: { specialist: 'Personal Trainer' },
            online_fitness: { specialist: 'Fitness Coach online' },
            yoga_instructor: { specialist: 'Istruttore di yoga' },
            pilates_instructor: { specialist: 'Istruttore di pilates' },
            psychologist: { specialist: 'Psicologo/a' },
            psychotherapist: { specialist: 'Psicoterapeuta' },
            speech_therapist: { specialist: 'Logopedista' },
            rehabilitation: { specialist: 'Specialista in riabilitazione' },
            osteopath: { specialist: 'Osteopata' },
            physiotherapist: { specialist: 'Fisioterapista' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Nutrizionista' },
            private_lawyer: { specialist: 'Avvocato privato' },
            attorney: { specialist: 'Avvocato' },
            tax_consultant: { specialist: 'Consulente fiscale' },
            accountant: { specialist: 'Commercialista' },
            financial_advisor: { specialist: 'Consulente finanziario' },
            mortgage_advisor: { specialist: 'Consulente mutui' },
            photographer: { specialist: 'Fotografo/a' },
            videographer: { specialist: 'Videografo/a' },
            event_host: { specialist: 'Animatore di eventi' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Tutor' },
            language_teacher: { specialist: 'Insegnante di lingue' },
            music_teacher: { specialist: 'Insegnante di musica' },
            child_psychologist: { specialist: 'Psicologo infantile' },
            school_prep: { specialist: 'Preparazione scolastica' },
            groomer: { specialist: 'Toelettatore/rice' },
            dogsitter: { specialist: 'Dog sitter' },
            dog_walker: { specialist: 'Dog walker' },
            dog_trainer: { specialist: 'Addestratore cinofilo' },
        },
    },
    pt: {
        aiServices: {
            nail_master: { specialist: 'Manicure / Pedicure' },
            hairdresser: { specialist: 'Cabeleireiro/a' },
            barber: { specialist: 'Barbeiro' },
            makeup_artist: { specialist: 'Maquiador/a' },
            brow_lash: { specialist: 'Designer de sobrancelhas/cílios' },
            cosmetologist: { specialist: 'Esteticista' },
            massage_therapist: { specialist: 'Massagista' },
            permanent_makeup: { specialist: 'Micropigmentação' },
            hair_extensions: { specialist: 'Extensão de cabelo' },
            laser_hair_removal: { specialist: 'Depilação a laser' },
            personal_trainer: { specialist: 'Personal Trainer' },
            online_fitness: { specialist: 'Coach fitness online' },
            yoga_instructor: { specialist: 'Instrutor de yoga' },
            pilates_instructor: { specialist: 'Instrutor de pilates' },
            psychologist: { specialist: 'Psicólogo/a' },
            psychotherapist: { specialist: 'Psicoterapeuta' },
            speech_therapist: { specialist: 'Fonoaudiólogo/a' },
            rehabilitation: { specialist: 'Especialista em reabilitação' },
            osteopath: { specialist: 'Osteopata' },
            physiotherapist: { specialist: 'Fisioterapeuta' },
            coach: { specialist: 'Coach' },
            nutritionist: { specialist: 'Nutricionista' },
            private_lawyer: { specialist: 'Advogado particular' },
            attorney: { specialist: 'Advogado/a' },
            tax_consultant: { specialist: 'Consultor fiscal' },
            accountant: { specialist: 'Contador/a' },
            financial_advisor: { specialist: 'Consultor financeiro' },
            mortgage_advisor: { specialist: 'Consultor de hipotecas' },
            photographer: { specialist: 'Fotógrafo/a' },
            videographer: { specialist: 'Videógrafo/a' },
            event_host: { specialist: 'Animador de eventos' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Tutor/a' },
            language_teacher: { specialist: 'Professor de idiomas' },
            music_teacher: { specialist: 'Professor de música' },
            child_psychologist: { specialist: 'Psicólogo infantil' },
            school_prep: { specialist: 'Preparação escolar' },
            groomer: { specialist: 'Tosquiador/a' },
            dogsitter: { specialist: 'Dog sitter' },
            dog_walker: { specialist: 'Passeador de cães' },
            dog_trainer: { specialist: 'Adestrador de cães' },
        },
    },
    cs: {
        aiServices: {
            nail_master: { specialist: 'Manikérka / Pedikérka' },
            hairdresser: { specialist: 'Kadeřník/ce' },
            barber: { specialist: 'Barber' },
            makeup_artist: { specialist: 'Vizážista' },
            brow_lash: { specialist: 'Brow/Lash stylista' },
            cosmetologist: { specialist: 'Kosmetička' },
            massage_therapist: { specialist: 'Masér/ka' },
            permanent_makeup: { specialist: 'Permanentní make-up' },
            hair_extensions: { specialist: 'Prodlužování vlasů' },
            laser_hair_removal: { specialist: 'Laserová epilace' },
            personal_trainer: { specialist: 'Osobní trenér/ka' },
            online_fitness: { specialist: 'Online fitness trenér' },
            yoga_instructor: { specialist: 'Instruktor/ka jógy' },
            pilates_instructor: { specialist: 'Instruktor/ka pilates' },
            psychologist: { specialist: 'Psycholog/žka' },
            psychotherapist: { specialist: 'Psychoterapeut/ka' },
            speech_therapist: { specialist: 'Logoped/ka' },
            rehabilitation: { specialist: 'Rehabilitační specialista' },
            osteopath: { specialist: 'Osteopat/ka' },
            physiotherapist: { specialist: 'Fyzioterapeut/ka' },
            coach: { specialist: 'Kouč' },
            nutritionist: { specialist: 'Nutriční poradce' },
            private_lawyer: { specialist: 'Soukromý právník' },
            attorney: { specialist: 'Advokát/ka' },
            tax_consultant: { specialist: 'Daňový poradce' },
            accountant: { specialist: 'Účetní' },
            financial_advisor: { specialist: 'Finanční poradce' },
            mortgage_advisor: { specialist: 'Hypoteční poradce' },
            photographer: { specialist: 'Fotograf/ka' },
            videographer: { specialist: 'Videograf/ka' },
            event_host: { specialist: 'Moderátor/ka' },
            dj: { specialist: 'DJ' },
            tutor: { specialist: 'Doučovatel/ka' },
            language_teacher: { specialist: 'Učitel/ka jazyků' },
            music_teacher: { specialist: 'Učitel/ka hudby' },
            child_psychologist: { specialist: 'Dětský psycholog' },
            school_prep: { specialist: 'Příprava do školy' },
            groomer: { specialist: 'Groomer' },
            dogsitter: { specialist: 'Hlídání psů' },
            dog_walker: { specialist: 'Venčení psů' },
            dog_trainer: { specialist: 'Cvičitel/ka psů' },
        },
    },
}
